import {
    FaExclamationTriangle,
    FaUsers,
    FaUserShield,
    FaTshirt,
    FaTasks,
    FaHardHat,
    FaSmoking,
    FaMapMarkerAlt,
    FaMountain,
    FaCloud,
    FaLightbulb,
    FaTools,
    FaCalendarAlt,
    FaFireAlt
} from 'react-icons/fa';
import moment from 'moment';

// Define project name and other configuration constants
const PROJECT_NAME = 'construction';
const PROJECT_DISPLAY_NAME = '工地';

// Define warning types and their display properties
const WARNING_TYPES = {
    accident_event: {
        icon: FaExclamationTriangle,
        label: '疑似事故',
        color: 'red'
    },
    dangerous_environment: {
        icon: FaFireAlt,
        label: '危險', // Will use the actual value from hit
        color: 'red'
    },
    anyone_not_wearing_helmets: {
        icon: FaUserShield,
        label: '無安全帽',
        color: 'red'
    },
    people_smoking: {
        icon: FaSmoking,
        label: '有人抽煙',
        color: 'red'
    }
};

// Define info types and their display properties
const INFO_TYPES = {
    number_of_people: { icon: FaUsers, color: '#007bff' },
    clothing: { icon: FaTshirt, color: '#007bff' },
    activity: { icon: FaTasks, color: '#007bff' },
    helmets: { icon: FaHardHat, color: '#007bff' },
    position: { icon: FaMapMarkerAlt, color: '#007bff' },
    location: { icon: FaMountain, color: '#007bff' },
    sky: { icon: FaCloud, color: '#007bff' },
    lighting: { icon: FaLightbulb, color: '#007bff' },
    equipment_quantity: { icon: FaTools, color: '#007bff', condition: value => value !== 0 },
    equipment_type: { icon: FaTools, color: '#007bff', condition: (_, hit) => hit.equipment_quantity !== 0 },
    timestamp: {
        icon: FaCalendarAlt,
        color: '#007bff',
        format: value => moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
};

export { PROJECT_NAME, PROJECT_DISPLAY_NAME, WARNING_TYPES, INFO_TYPES }; 